import { MapPin, Clock, Navigation, Phone, ExternalLink } from "lucide-react";
import { site } from "@/config/site";
import { SectionHeading } from "./SectionHeading";

export const MapSection = ({ title = "Ziyaret Edin", accent = "Bizi", id = "konum" }) => (
  <section id={id} className="section bg-offwhite" aria-labelledby={`${id}-title`} data-testid="map-section">
    <div className="container-wide">
      <SectionHeading eyebrow="Konum" accent={accent} title={title} lead="Nilüfer · Konak Mahallesi · Kurşunlu Sokak" id={`${id}-title`} />
      <div className="grid gap-6 lg:grid-cols-3">
        <div className="lg:col-span-2 relative rounded-2xl overflow-hidden border border-black/10 shadow-xl bg-emerald/5">
          <iframe
            src={site.mapsEmbedUrl}
            title="Lavenza Masaj Salonu konumu – Google Haritalar"
            width="100%"
            height="450"
            loading="lazy"
            referrerPolicy="no-referrer-when-downgrade"
            allowFullScreen
            className="block w-full h-[340px] sm:h-[450px]"
            data-testid="map-iframe"
          />
          <div className="absolute bottom-4 right-4 flex flex-wrap gap-2 justify-end">
            <a href={site.mapsSearchUrl} target="_blank" rel="noopener noreferrer" className="btn btn-sm bg-white text-emerald border border-black/10 shadow-lg hover:bg-offwhite" data-testid="maps-link">
              <ExternalLink size={16} aria-hidden="true" /> Google Maps
            </a>
            <a href={site.mapsDirectionsUrl} target="_blank" rel="noopener noreferrer" className="btn btn-emerald btn-sm" data-testid="directions-link">
              <Navigation size={16} aria-hidden="true" /> Yol tarifi al
            </a>
          </div>
        </div>
        <address className="not-italic space-y-4">
          <div className="rounded-2xl border-2 border-gold/30 bg-gradient-to-br from-gold/10 to-white p-6">
            <MapPin className="w-6 h-6 text-gold mb-3" aria-hidden="true" />
            <h3 className="font-bold mb-2">Adres</h3>
            <p className="text-sm text-muted leading-relaxed" data-testid="address-text">{site.address.street}<br />{site.address.locality} / {site.address.region}</p>
          </div>
          <div className="card p-6">
            <Phone className="w-6 h-6 text-gold mb-3" aria-hidden="true" />
            <h3 className="font-bold mb-2">Telefon</h3>
            <a href={site.phoneTel} className="text-base font-semibold text-emerald" data-testid="map-phone-link">{site.phoneDisplay}</a>
          </div>
          <div className="card p-6">
            <Clock className="w-6 h-6 text-gold mb-3" aria-hidden="true" />
            <h3 className="font-bold mb-2">Çalışma Saatleri</h3>
            <p className="text-sm text-muted" data-testid="hours-text">{site.openingHours.text}</p>
          </div>
        </address>
      </div>
    </div>
  </section>
);
